import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css / index-new.css not found, proceeding without it.');
}
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef, useState, useEffect, useCallback } from 'react';
import { useQueryClient, useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { Button } from '@design-system/button';
import { CheckboxField } from '@design-system/checkbox-field';
import { CheckboxList } from '@design-system/checkbox-list';
import { DateField } from '@design-system/date-field';
import { ErrorMessage } from '@design-system/error-message';
import { InputField } from '@design-system/input-field';
import { LegalField } from '@design-system/legal-field';
import { LongTextField } from '@design-system/long-text-field';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { getQueries, useConditionsWatch } from '@promo-platform/utils';
import { isBefore, isAfter, differenceInYears } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { FieldHead } from '@design-system/field-head';
import { Icon } from '@design-system/icon';
import { HeadingBlock } from '@design-system/heading-block';
import { RadioList } from '@design-system/radio-list';
import { Dropdown } from '@design-system/dropdown';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var getFormData = function getFormData(url, id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$axios$get, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("".concat(url, "/").concat(id));
          case 2:
            _yield$axios$get = _context.sent;
            data = _yield$axios$get.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
var sendFormData = function sendFormData(_ref) {
  var url = _ref.url,
    formId = _ref.formId,
    body = _ref.body,
    token = _ref.token;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _yield$axios$post, data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.post("".concat(url, "/").concat(formId, "/response"), {
              responses: body,
              captchaToken: token || null
            });
          case 2:
            _yield$axios$post = _context2.sent;
            data = _yield$axios$post.data;
            return _context2.abrupt("return", data);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
var FORM;
(function (FORM) {
  FORM["FORM_ID"] = "form-creator-form";
  FORM["ID"] = "id";
  FORM["NAME_DESCRIPTION_CARD_ID"] = "form-name-description-card";
  FORM["RESULT_CARD_ID"] = "form-result-card";
  FORM["FIELD_ARRAY_ID"] = "fieldArrayId";
  FORM["TITLE"] = "title";
  FORM["DESCRIPTION"] = "description";
  FORM["START_DATE_TIME_SETTINGS"] = "startDateSettings";
  FORM["END_DATE_TIME_SETTINGS"] = "endDateSettings";
  FORM["DATE_TIME"] = "localDateTime";
  FORM["REDIRECT_URL"] = "redirectUrl";
  FORM["TIME_ZONE"] = "timeZoneInfo";
  FORM["SUBMIT_BUTTON_TEXT"] = "submitButtonText";
  FORM["SUBMIT_BUTTON_ARIA_LABEL"] = "submitButtonDescription";
  FORM["BACK_BUTTON_TEXT"] = "backButtonText";
  FORM["BACK_BUTTON_ARIA_LABEL"] = "backButtonDescription";
  FORM["THANK_YOU_PAGE_URL"] = "thankYouPageUrl";
  FORM["LABEL"] = "label";
  FORM["ALIAS"] = "alias";
  FORM["TYPE"] = "type";
  FORM["TOOLTIP_TEXT"] = "tooltip";
  FORM["TOOLTIP_LABEL"] = "tooltipLabel";
  FORM["SECTIONS"] = "sections";
  FORM["FIELDS"] = "fields";
  FORM["PLACEHOLDER"] = "placeholder";
  FORM["ERROR_MESSAGE"] = "errorMessage";
  FORM["VALUE"] = "value";
  FORM["OPERATOR"] = "operator";
  FORM["IS_SELECTED"] = "isSelected";
  FORM["MANDATORY_VALIDATION"] = "mandatoryValidation";
  FORM["MIN_LENGTH_VALIDATION"] = "minLengthValidation";
  FORM["MAX_LENGTH_VALIDATION"] = "maxLengthValidation";
  FORM["MAX_FILE_SIZE_VALIDATION"] = "maxFileSizeValidation";
  FORM["MAX_NUMBER_OF_ANSWERS_VALIDATION"] = "maxNumberOfAnswersValidation";
  FORM["MIN_NUMBER_OF_ANSWERS_VALIDATION"] = "minNumberOfAnswersValidation";
  FORM["MAX_VALUE_VALIDATION"] = "maxValueValidation";
  FORM["MIN_VALUE_VALIDATION"] = "minValueValidation";
  FORM["PATTERN_VALIDATION"] = "patternValidation";
  FORM["ACCEPTED_FILE_TYPES_VALIDATION"] = "acceptedFileTypesValidation";
  FORM["DATE_LIMITATION_VALIDATION"] = "dateLimitationValidation";
  FORM["ACCEPTED_FILE_TYPES"] = "acceptedFileTypes";
  FORM["LIST_OF_VALUES"] = "listOfValues";
  FORM["NUMBER_OF_ROWS"] = "numberOfRows";
  FORM["LEGAL_DOCUMENT_SOURCE_TYPE"] = "legalDocumentSourceType";
  FORM["DEFAULT_VALUE"] = "defaultValue";
  FORM["RECAPTCHA_SITE_KEY"] = "recaptchaSiteKey";
  FORM["SEND_DATA_ON_EACH_SECTION_SUBMIT"] = "sendDataOnEachSectionSubmit";
  FORM["IS_HIDDEN"] = "isHidden";
  FORM["CONDITIONS"] = "conditions";
  FORM["SEND_TO_THANK_YOU_PAGE"] = "sendToThankYouPage";
})(FORM || (FORM = {}));
var FORM_TYPES;
(function (FORM_TYPES) {
  FORM_TYPES["ShortTextField"] = "ShortTextField";
  FORM_TYPES["LongTextField"] = "LongTextField";
  FORM_TYPES["BooleanField"] = "BooleanField";
  FORM_TYPES["SelectListField"] = "SelectListField";
  FORM_TYPES["SelectField"] = "SelectField";
  FORM_TYPES["AttachFileField"] = "AttachFileField";
  FORM_TYPES["LegalField"] = "LegalField";
  FORM_TYPES["DateField"] = "DateField";
  FORM_TYPES["IntegerField"] = "IntegerField";
  FORM_TYPES["CheckboxList"] = "CheckboxList";
})(FORM_TYPES || (FORM_TYPES = {}));
var OperatorType;
(function (OperatorType) {
  OperatorType["GT"] = "Gt";
  OperatorType["LT"] = "Lt";
})(OperatorType || (OperatorType = {}));
var parseRegex = function parseRegex(regex) {
  if (!regex) {
    return undefined;
  }
  var parts = /\/(.*)\/(.*)/.exec("".concat(regex)) || /\/(.*)\/(.*)/.exec("/".concat(regex, "/"));
  return parts ? new RegExp(parts[1], parts[2]) : undefined;
};
var prepareLegalBody = function prepareLegalBody(_ref2) {
  var formData = _ref2.formData,
    field = _ref2.field,
    queryClient = _ref2.queryClient;
  var queries = getQueries(field.description);
  var ldsArray = queries.map(function (lds) {
    var data = queryClient.getQueryData(lds.data.legalDocumentId);
    if (!data) {
      return null;
    }
    return {
      documentId: data.documentId || lds.data.legalDocumentId,
      revisionId: data.revisionId || data.versionId
    };
  }).filter(function (item) {
    return item;
  });
  return {
    type: field.type,
    id: field.id,
    value: formData[field.alias],
    legalDocuments: ldsArray.length > 0 ? ldsArray : null
  };
};
var prepareBody = function prepareBody(requestData, formData, queryClient) {
  var body = requestData.sections.map(function (_ref3) {
    var fields = _ref3.fields;
    return fields.filter(function (field) {
      return !field.conditions.length || field.alias in formData;
    }).map(function (field) {
      var _a, _b;
      if (field.type === FORM_TYPES.AttachFileField) {
        var fileValue = ((_a = formData[field.alias]) === null || _a === void 0 ? void 0 : _a.length) > 0 ? formData[field.alias].map(function (file) {
          return file.value;
        }) : null;
        return {
          type: field.type,
          id: field.id,
          value: fileValue
        };
      }
      if (field.type === FORM_TYPES.LegalField) {
        return prepareLegalBody({
          formData: formData,
          field: field,
          queryClient: queryClient
        });
      }
      if (field.type === FORM_TYPES.SelectListField) {
        return {
          type: field.type,
          id: field.id,
          value: typeof formData[field.alias] === 'string' ? [formData[field.alias]] : formData[field.alias]
        };
      }
      if (field.type === FORM_TYPES.BooleanField) {
        return {
          type: field.type,
          id: field.id,
          value: formData[field.alias] || false
        };
      }
      return {
        type: field.type,
        id: field.id,
        value: ((_b = formData[field.alias]) === null || _b === void 0 ? void 0 : _b.value) || formData[field.alias] || null
      };
    });
  });
  return body.flat();
};
var findUtmParemeter = function findUtmParemeter(label, utmParameters) {
  return utmParameters === null || utmParameters === void 0 ? void 0 : utmParameters.find(function (_ref4) {
    var name = _ref4.name;
    return name === label;
  });
};
var mapApiResponse = function mapApiResponse(_ref5) {
  var apiProps = _ref5.apiProps,
    settings = _ref5.settings,
    utmParameters = _ref5.utmParameters;
  var _a;
  switch (apiProps.type) {
    case FORM_TYPES.SelectListField:
    case FORM_TYPES.SelectField:
      return Object.assign(Object.assign({}, apiProps), {
        options: apiProps.listOfValues.map(function (_ref6) {
          var alias = _ref6.alias,
            value = _ref6.value,
            isSelected = _ref6.isSelected;
          return {
            value: alias,
            label: value,
            isSelected: isSelected
          };
        })
      });
    case FORM_TYPES.LegalField:
      return Object.assign(Object.assign({}, apiProps), {
        type: 'checkbox',
        config: settings === null || settings === void 0 ? void 0 : settings.config
      });
    case FORM_TYPES.BooleanField:
      return Object.assign(Object.assign({}, apiProps), {
        type: 'checkbox'
      });
    case FORM_TYPES.ShortTextField:
      return Object.assign(Object.assign({}, apiProps), {
        defaultValue: apiProps.isHidden && ((_a = findUtmParemeter(apiProps.label, utmParameters)) === null || _a === void 0 ? void 0 : _a.value) || apiProps.defaultValue
      });
    default:
      return apiProps;
  }
};
var transpileValidationRule = function transpileValidationRule(rule) {
  if (!(rule === null || rule === void 0 ? void 0 : rule.value)) return undefined;
  var value = rule.value,
    _rule$errorMessage = rule.errorMessage,
    errorMessage = _rule$errorMessage === void 0 ? '' : _rule$errorMessage;
  return {
    value: value,
    message: errorMessage
  };
};
var validateDateLimitation = function validateDateLimitation(value, dateLimitationValidation) {
  if (!dateLimitationValidation) return undefined;
  var days = differenceInYears(new Date(), new Date(value));
  var zeroNumber = 0;
  if (days < zeroNumber) {
    return dateLimitationValidation.errorMessage;
  }
  if (dateLimitationValidation.operator === OperatorType.GT && days < dateLimitationValidation.value) {
    return dateLimitationValidation.errorMessage;
  }
  if (dateLimitationValidation.operator === OperatorType.LT && days > dateLimitationValidation.value) {
    return dateLimitationValidation.errorMessage;
  }
  return undefined;
};
var prepareFieldProps = function prepareFieldProps(_ref7) {
  var apiProps = _ref7.apiProps,
    settings = _ref7.settings,
    utmParameters = _ref7.utmParameters,
    register = _ref7.register,
    errors = _ref7.errors,
    setValue = _ref7.setValue,
    uniqueFormPrefix = _ref7.uniqueFormPrefix;
  var _a;
  var fieldProps = mapApiResponse({
    apiProps: apiProps,
    settings: settings,
    utmParameters: utmParameters
  });
  if ('sendToThankYouPage' in fieldProps) delete fieldProps.sendToThankYouPage;
  var alias = fieldProps.alias,
    defaultValue = fieldProps.defaultValue,
    mandatoryValidation = fieldProps.mandatoryValidation,
    minLengthValidation = fieldProps.minLengthValidation,
    maxLengthValidation = fieldProps.maxLengthValidation,
    patternValidation = fieldProps.patternValidation,
    dateLimitationValidation = fieldProps.dateLimitationValidation,
    tooltip = fieldProps.tooltip,
    _sendToThankYouPage = fieldProps.sendToThankYouPage,
    restFieldProps = __rest(fieldProps, ["alias", "defaultValue", "mandatoryValidation", "minLengthValidation", "maxLengthValidation", "patternValidation", "dateLimitationValidation", "tooltip", "sendToThankYouPage"]);
  return Object.assign(Object.assign(Object.assign(Object.assign({}, restFieldProps), register(alias, {
    required: mandatoryValidation === null || mandatoryValidation === void 0 ? void 0 : mandatoryValidation.errorMessage,
    minLength: transpileValidationRule(minLengthValidation),
    maxLength: transpileValidationRule(maxLengthValidation),
    pattern: transpileValidationRule({
      value: parseRegex(patternValidation === null || patternValidation === void 0 ? void 0 : patternValidation.value),
      errorMessage: patternValidation === null || patternValidation === void 0 ? void 0 : patternValidation.errorMessage
    }),
    validate: function validate(value) {
      return validateDateLimitation(value, dateLimitationValidation);
    },
    value: defaultValue
  })), {
    errorMessage: (_a = errors[alias]) === null || _a === void 0 ? void 0 : _a.message,
    tooltipText: tooltip,
    id: "".concat(uniqueFormPrefix, "_").concat(apiProps.id)
  }), apiProps.type === FORM_TYPES.AttachFileField ? {
    setValue: setValue
  } : null);
};
var redirectFunction = function redirectFunction(url, callback) {
  if (callback) {
    callback(url);
  } else {
    window.open(url, '_self');
  }
};
var isFormInactive = function isFormInactive(startDateSettings, endDateSettings, callback) {
  if (startDateSettings) {
    var newDate = utcToZonedTime(new Date(), startDateSettings.timeZoneInfo);
    var utcDate = utcToZonedTime(startDateSettings.localDateTime, startDateSettings.timeZoneInfo);
    if (isBefore(newDate, utcDate)) {
      redirectFunction(startDateSettings.redirectUrl, callback);
    }
  }
  if (endDateSettings) {
    var _newDate = utcToZonedTime(new Date(), endDateSettings.timeZoneInfo);
    var _utcDate = utcToZonedTime(endDateSettings.localDateTime, endDateSettings.timeZoneInfo);
    if (isAfter(_newDate, _utcDate)) {
      redirectFunction(endDateSettings.redirectUrl, callback);
    }
  }
};
var KB = 1024;
var DEFAULT_ACCEPTED_FILE_TYPES = {
  infoMessage: 'You may upload {{acceptedFileTypes}} files.',
  placeholderToReplace: '{{acceptedFileTypes}}'
};
var DEFAULT_MAX_FILE_SIZE = {
  infoMessage: 'Max file size: {{value}}MB',
  placeholderToReplace: '{{value}}'
};
var convertToMB = function convertToMB(size) {
  return parseFloat((size / (KB * KB)).toFixed(2));
};
var convertBase64 = function convertBase64(file) {
  return new Promise(function (resolve, reject) {
    var fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = function () {
      resolve(fileReader.result);
    };
    fileReader.onerror = function (error) {
      reject(error);
    };
  });
};
var base64Handler = function base64Handler(files) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var filePathsPromises, filePaths;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            filePathsPromises = files.map(function (file) {
              return convertBase64(file);
            });
            _context3.next = 3;
            return Promise.all(filePathsPromises);
          case 3:
            filePaths = _context3.sent;
            return _context3.abrupt("return", filePaths.map(function (base64File, index) {
              return {
                value: base64File,
                name: files[index].name,
                size: files[index].size,
                type: files[index].type
              };
            }));
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
var setAcceptedFileTypesLabel = function setAcceptedFileTypesLabel(acceptedFileTypesValidation) {
  return acceptedFileTypesValidation.infoMessage ? acceptedFileTypesValidation.infoMessage.replace(acceptedFileTypesValidation.placeholderToReplace, "".concat(acceptedFileTypesValidation.acceptedFileTypes.join(', ').toLowerCase())) : DEFAULT_ACCEPTED_FILE_TYPES.infoMessage.replace(DEFAULT_ACCEPTED_FILE_TYPES.placeholderToReplace, "".concat(acceptedFileTypesValidation.acceptedFileTypes.join(', ').toLowerCase()));
};
var setMaxFileSizeValidationLabel = function setMaxFileSizeValidationLabel(maxFileSizeValidation) {
  return maxFileSizeValidation.infoMessage ? maxFileSizeValidation.infoMessage.replace(maxFileSizeValidation.placeholderToReplace, "".concat(maxFileSizeValidation.value)) : DEFAULT_MAX_FILE_SIZE.infoMessage.replace(DEFAULT_MAX_FILE_SIZE.placeholderToReplace, "".concat(maxFileSizeValidation.value));
};
var AttachFileField = forwardRef(function (_ref8, ref) {
  var name = _ref8.name,
    _ref8$browseFileLabel = _ref8.browseFileLabel,
    browseFileLabel = _ref8$browseFileLabel === void 0 ? 'Browse your files' : _ref8$browseFileLabel,
    acceptedFileTypesValidation = _ref8.acceptedFileTypesValidation,
    maxFileSizeValidation = _ref8.maxFileSizeValidation,
    id = _ref8.id,
    label = _ref8.label,
    description = _ref8.description,
    tooltipText = _ref8.tooltipText,
    tooltipLabel = _ref8.tooltipLabel,
    disabled = _ref8.disabled,
    maxNumberOfFilesValidation = _ref8.maxNumberOfFilesValidation,
    onChange = _ref8.onChange,
    onDrop = _ref8.onDrop,
    setValue = _ref8.setValue;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    addedFiles = _useState2[0],
    setAddedFiles = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  useEffect(function () {
    setErrorMessage('');
    var setFiles = function setFiles() {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var filesWithBase64;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return base64Handler(addedFiles);
              case 2:
                filesWithBase64 = _context4.sent;
                setValue(name, filesWithBase64, {
                  shouldValidate: true,
                  shouldDirty: true
                });
              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    };
    if (addedFiles) setFiles();
  }, [addedFiles]);
  var checkValidation = function checkValidation(allFiles) {
    if (!allFiles === null || !(allFiles === null || allFiles === void 0 ? void 0 : allFiles[0])) return false;
    if (maxNumberOfFilesValidation && Array.from(allFiles).length > maxNumberOfFilesValidation.value) {
      setErrorMessage(maxNumberOfFilesValidation.errorMessage);
      return false;
    }
    if (maxFileSizeValidation) {
      var isSizeValid = !Array.from(allFiles).some(function (file) {
        return convertToMB(file.size) > (maxFileSizeValidation === null || maxFileSizeValidation === void 0 ? void 0 : maxFileSizeValidation.value) || 0;
      });
      if (!isSizeValid) {
        setErrorMessage(maxFileSizeValidation.errorMessage);
        return false;
      }
    }
    setAddedFiles(function (prevFiles) {
      return prevFiles ? [].concat(_toConsumableArray(prevFiles), _toConsumableArray(Array.from(allFiles))) : Array.from(allFiles);
    });
    return true;
  };
  var handleOnChange = useCallback(function (event) {
    var files = event.target.files;
    var isValidationPassed = checkValidation(files);
    if (isValidationPassed && onChange) {
      onChange(event);
    }
  }, [onChange]);
  var handleOnDrop = useCallback(function (event) {
    if (event.dataTransfer) {
      var files = event.dataTransfer.files;
      var isValidationPassed = checkValidation(files);
      if (isValidationPassed && onDrop) {
        onDrop(event);
      }
    }
  }, [onDrop]);
  var removeFile = function removeFile(fileName) {
    setAddedFiles(addedFiles === null || addedFiles === void 0 ? void 0 : addedFiles.filter(function (file) {
      return file.name !== fileName;
    }));
  };
  return jsxs("div", Object.assign({
    className: "cds-promo-form-attach-field"
  }, {
    children: [jsx(FieldHead, {
      id: id,
      label: label,
      description: description,
      tooltipText: tooltipText,
      tooltipLabel: tooltipLabel
    }), jsx("input", {
      ref: ref,
      className: "cds-promo-form-attach-field__file-input",
      id: "pp-".concat(name),
      accept: acceptedFileTypesValidation.acceptedFileTypes.map(function (item) {
        return ".".concat(item.toLowerCase());
      }).join(','),
      "data-test": "attach-field",
      name: name,
      multiple: maxNumberOfFilesValidation && maxNumberOfFilesValidation.value > 1,
      onChange: handleOnChange,
      type: "file"
    }), jsxs("label", Object.assign({
      htmlFor: "pp-".concat(name),
      onDrop: handleOnDrop,
      className: classNames('cds-promo-form-attach-field__label', {
        'cds-promo-form-attach-field__label--disabled': disabled,
        'cds-promo-form-attach-field__label--error': Boolean(errorMessage)
      })
    }, {
      children: [jsx("span", {
        className: classNames('cds-promo-form-attach-field__button', {
          'cds-promo-form-attach-field__button--disabled': disabled
        }),
        role: "button"
      }), browseFileLabel && jsx("span", Object.assign({
        className: "cds-promo-form-attach-field__info"
      }, {
        children: browseFileLabel
      }))]
    })), jsx(ErrorMessage, {
      className: "cds-promo-form-attach-field__error",
      message: errorMessage
    }), acceptedFileTypesValidation && jsx("div", Object.assign({
      className: "cds-promo-form-attach-field__accepted-file-types"
    }, {
      children: jsx("span", {
        children: setAcceptedFileTypesLabel(acceptedFileTypesValidation)
      })
    })), maxFileSizeValidation && jsx("div", Object.assign({
      className: "cds-promo-form-attach-field__max-file-size"
    }, {
      children: jsx("span", {
        children: setMaxFileSizeValidationLabel(maxFileSizeValidation)
      })
    })), addedFiles && jsx("div", Object.assign({
      className: "cds-promo-form-attach-field__files"
    }, {
      children: addedFiles.map(function (file) {
        return jsxs("div", Object.assign({
          className: "cds-promo-form-attach-field__file"
        }, {
          children: [jsx(Icon, {
            icon: "file"
          }), jsx("div", Object.assign({
            className: "cds-promo-form-attach-field__infoContainer"
          }, {
            children: jsx("div", Object.assign({
              className: "cds-promo-form-attach-field__name"
            }, {
              children: file.name
            }))
          })), jsx("button", Object.assign({
            type: "button",
            className: "cds-promo-form-attach-field__removeButton",
            onClick: function onClick() {
              return removeFile(file.name);
            }
          }, {
            children: jsx(Icon, {
              icon: "trashRemove"
            })
          }))]
        }), file.name);
      })
    }))]
  }));
});
var FormComponentsRenderer = function FormComponentsRenderer(_ref9) {
  var WrappedComponent = _ref9.WrappedComponent,
    watch = _ref9.watch,
    unregister = _ref9.unregister,
    settings = _ref9.settings,
    utmParameters = _ref9.utmParameters,
    register = _ref9.register,
    errors = _ref9.errors,
    setValue = _ref9.setValue,
    uniqueFormPrefix = _ref9.uniqueFormPrefix,
    props = _ref9.props;
  var shouldRender = useConditionsWatch(watch, props.conditions);
  useEffect(function () {
    if (!shouldRender && props.alias) {
      unregister(props.alias);
    }
  }, [shouldRender, unregister, props.alias]);
  if (!shouldRender) return null;
  var preparedProps = prepareFieldProps({
    apiProps: props,
    settings: settings,
    utmParameters: utmParameters,
    register: register,
    errors: errors,
    setValue: setValue,
    uniqueFormPrefix: uniqueFormPrefix
  });
  return jsx(WrappedComponent, Object.assign({}, preparedProps));
};
var SeparatorIcon = function SeparatorIcon() {
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "30.828",
    height: "54.828",
    viewBox: "0 0 30.828 54.828"
  }, {
    children: jsxs("g", Object.assign({
      id: "Group_1175",
      "data-name": "Group 1175",
      transform: "translate(-191.586 -382.336)"
    }, {
      children: [jsxs("g", Object.assign({
        id: "Group_1143",
        "data-name": "Group 1143",
        transform: "translate(-469.5 -269.75)"
      }, {
        children: [jsx("line", {
          id: "Line_32",
          "data-name": "Line 32",
          x2: "14",
          y2: "14",
          transform: "translate(662.5 653.5)",
          fill: "none",
          stroke: "#707070",
          strokeLinecap: "round",
          strokeWidth: "2"
        }), jsx("line", {
          id: "Line_33",
          "data-name": "Line 33",
          y1: "14",
          x2: "14",
          transform: "translate(676.5 653.5)",
          fill: "none",
          stroke: "#707070",
          strokeLinecap: "round",
          strokeWidth: "2"
        })]
      })), jsxs("g", Object.assign({
        id: "Group_1144",
        "data-name": "Group 1144",
        transform: "translate(-469.5 -264.75)"
      }, {
        children: [jsx("line", {
          id: "Line_35",
          "data-name": "Line 35",
          x2: "14",
          y2: "14",
          transform: "translate(662.5 667.5)",
          fill: "none",
          stroke: "#d4d4d4",
          strokeLinecap: "round",
          strokeWidth: "2"
        }), jsx("line", {
          id: "Line_34",
          "data-name": "Line 34",
          y1: "14",
          x2: "14",
          transform: "translate(676.5 667.5)",
          fill: "none",
          stroke: "#d4d4d4",
          strokeLinecap: "round",
          strokeWidth: "2"
        })]
      })), jsxs("g", Object.assign({
        id: "Group_1145",
        "data-name": "Group 1145",
        transform: "translate(-469.5 -259.75)"
      }, {
        children: [jsx("line", {
          id: "Line_37",
          "data-name": "Line 37",
          x2: "14",
          y2: "14",
          transform: "translate(662.5 681.5)",
          fill: "none",
          stroke: "#f2f2f2",
          strokeLinecap: "round",
          strokeWidth: "2"
        }), jsx("line", {
          id: "Line_36",
          "data-name": "Line 36",
          y1: "14",
          x2: "14",
          transform: "translate(676.5 681.5)",
          fill: "none",
          stroke: "#f2f2f2",
          strokeLinecap: "round",
          strokeWidth: "2"
        })]
      }))]
    }))
  }));
};
var PromoFormHeading = function PromoFormHeading(_ref10) {
  var data = _ref10.data,
    align = _ref10.align;
  return jsxs(Fragment, {
    children: [data ? jsx(HeadingBlock, {
      align: align,
      className: "cds-promo-form__heading",
      headline: data.title,
      headlineTag: "h2",
      description: data.description
    }) : 'WIP', jsx("div", Object.assign({
      className: classNames('cds-promo-form__separator', "cds-justify--".concat(align))
    }, {
      children: jsx(SeparatorIcon, {})
    }))]
  });
};
var SelectWrapper = forwardRef(function (_a, ref) {
  var onChange = _a.onChange,
    name = _a.name,
    rest = __rest(_a, ["onChange", "name"]);
  var patchedOnChange = useCallback(function (selectValue) {
    if (onChange) {
      onChange({
        target: {
          name: name,
          value: selectValue
        }
      });
    }
  }, [name, onChange]);
  return jsx(Dropdown, Object.assign({}, rest, {
    name: name,
    onChange: patchedOnChange,
    ref: ref
  }));
});
var SelectListField = forwardRef(function (_a, ref) {
  var maxNumberOfAnswersValidation = _a.maxNumberOfAnswersValidation,
    name = _a.name,
    onChange = _a.onChange,
    rest = __rest(_a, ["maxNumberOfAnswersValidation", "name", "onChange"]);
  var patchedOnRadioChange = useCallback(function (_ref11) {
    var value = _ref11.value;
    if (onChange) {
      onChange({
        target: {
          value: value,
          name: name
        }
      });
    }
  }, [name, onChange]);
  if (maxNumberOfAnswersValidation && maxNumberOfAnswersValidation.value > 1) {
    return jsx(SelectWrapper, Object.assign({}, rest, {
      isMulti: true,
      name: name,
      ref: ref
    }));
  }
  return jsx(RadioList, Object.assign({}, rest, {
    onChange: patchedOnRadioChange,
    ref: ref
  }));
});
var PromoForm = function PromoForm(_ref12) {
  var url = _ref12.url,
    settings = _ref12.settings,
    formId = _ref12.formId,
    submitErrorMessage = _ref12.submitErrorMessage,
    onSuccessCallback = _ref12.onSuccessCallback,
    onRedirectCallback = _ref12.onRedirectCallback,
    utmParameters = _ref12.utmParameters,
    _ref12$align = _ref12.align,
    align = _ref12$align === void 0 ? 'center' : _ref12$align,
    _ref12$showHeading = _ref12.showHeading,
    showHeading = _ref12$showHeading === void 0 ? true : _ref12$showHeading,
    disabled = _ref12.disabled;
  var queryClient = useQueryClient();
  var _useQuery = useQuery("promoData_".concat(formId), function () {
      return getFormData(url, formId);
    }),
    data = _useQuery.data;
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    token = _useState6[0],
    setToken = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    formError = _useState8[0],
    setFormError = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    currentStep = _useState10[0],
    setCurrentStep = _useState10[1];
  var _useState11 = useState(function () {
      return "".concat(Math.random().toString(16).slice(2).substring(0, 8), "ui");
    }),
    _useState12 = _slicedToArray(_useState11, 1),
    uniqueFormPrefix = _useState12[0];
  var _useForm = useForm(),
    handleSubmit = _useForm.handleSubmit,
    register = _useForm.register,
    _useForm$formState = _useForm.formState,
    isSubmitting = _useForm$formState.isSubmitting,
    errors = _useForm$formState.errors,
    reset = _useForm.reset,
    setValue = _useForm.setValue,
    watch = _useForm.watch,
    unregister = _useForm.unregister,
    getValues = _useForm.getValues,
    trigger = _useForm.trigger;
  var componentsMap = Object.assign({
    ShortTextField: InputField,
    LongTextField: LongTextField,
    BooleanField: CheckboxField,
    SelectField: SelectWrapper,
    LegalField: LegalField,
    SelectListField: SelectListField,
    AttachFileField: AttachFileField,
    DateField: DateField,
    CheckboxList: CheckboxList
  }, (settings === null || settings === void 0 ? void 0 : settings.components) || {});
  useEffect(function () {
    if (!data) return;
    isFormInactive(data.startDateSettings, data.endDateSettings, onRedirectCallback);
  }, [data, onRedirectCallback]);
  var onSuccess = function onSuccess(redirectUrl) {
    if (onSuccessCallback) {
      onSuccessCallback(redirectUrl, reset);
    } else {
      window.open(redirectUrl, '_self');
    }
  };
  var handleToken = function handleToken(value) {
    if (token) return;
    setToken(value);
  };
  var onSubmit = function onSubmit(values) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var triggerResult, body;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (data) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              _context5.next = 4;
              return trigger();
            case 4:
              triggerResult = _context5.sent;
              if (triggerResult) {
                _context5.next = 7;
                break;
              }
              return _context5.abrupt("return");
            case 7:
              body = prepareBody(data, values, queryClient);
              _context5.prev = 8;
              _context5.next = 11;
              return sendFormData({
                url: url,
                formId: formId,
                body: body,
                token: token
              });
            case 11:
              onSuccess(data.thankYouPageUrl);
              _context5.next = 17;
              break;
            case 14:
              _context5.prev = 14;
              _context5.t0 = _context5["catch"](8);
              setFormError(submitErrorMessage);
            case 17:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[8, 14]]);
    }));
  };
  var handleNext = function handleNext() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var values, fieldsToValidation, triggerResult, body;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (data) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              values = getValues();
              fieldsToValidation = data.sections[currentStep].fields.map(function (props) {
                return props.alias;
              });
              _context6.next = 6;
              return trigger(fieldsToValidation);
            case 6:
              triggerResult = _context6.sent;
              if (triggerResult) {
                _context6.next = 9;
                break;
              }
              return _context6.abrupt("return");
            case 9:
              if (currentStep < data.sections.length - 1) {
                setTimeout(function () {
                  setCurrentStep(currentStep + 1);
                }, 200);
              }
              if (!data.sendDataOnEachSectionSubmit) {
                _context6.next = 20;
                break;
              }
              body = prepareBody(data, values, queryClient);
              _context6.prev = 12;
              _context6.next = 15;
              return sendFormData({
                url: url,
                formId: formId,
                body: body,
                token: token
              });
            case 15:
              _context6.next = 20;
              break;
            case 17:
              _context6.prev = 17;
              _context6.t0 = _context6["catch"](12);
              setFormError(submitErrorMessage);
            case 20:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[12, 17]]);
    }));
  };
  var handlePrevious = function handlePrevious() {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };
  var groupFields = function groupFields(fields) {
    var renderedFields = [];
    var checkboxList = {
      type: FORM_TYPES.CheckboxList,
      fields: []
    };
    fields === null || fields === void 0 ? void 0 : fields.forEach(function (field) {
      var _a;
      if (field.type === 'BooleanField' || field.type === 'LegalField') {
        checkboxList.fields.push(field);
        checkboxList.errorMessage = checkboxList.errorMessage || ((_a = errors[field.alias]) === null || _a === void 0 ? void 0 : _a.message);
      } else {
        if (checkboxList.fields.length > 0) {
          renderedFields.push(checkboxList);
          checkboxList = {
            type: FORM_TYPES.CheckboxList,
            fields: []
          };
        }
        renderedFields.push(field);
      }
    });
    if (checkboxList.fields.length > 0) {
      renderedFields.push(checkboxList);
    }
    return renderedFields;
  };
  return jsxs(GoogleReCaptchaProvider, Object.assign({
    reCaptchaKey: data === null || data === void 0 ? void 0 : data.recaptchaSiteKey
  }, {
    children: [jsxs("form", Object.assign({
      onSubmit: handleSubmit(onSubmit),
      className: "cds-promo-form"
    }, {
      children: [showHeading ? jsx(PromoFormHeading, {
        data: data,
        align: align
      }) : null, (data === null || data === void 0 ? void 0 : data.sections) && data.sections[currentStep] ? jsxs(Fragment, {
        children: [jsx("fieldset", Object.assign({
          className: "cds-promo-form__fields",
          disabled: disabled
        }, {
          children: groupFields(data === null || data === void 0 ? void 0 : data.sections[currentStep].fields).map(function (fieldGroup) {
            return fieldGroup.type === 'CheckboxList' ? jsx(CheckboxList, Object.assign({
              errorMessage: fieldGroup.errorMessage
            }, {
              children: fieldGroup.fields.map(function (field) {
                return jsx(FormComponentsRenderer, {
                  WrappedComponent: componentsMap[field.type],
                  props: field,
                  register: register,
                  setValue: setValue,
                  unregister: unregister,
                  watch: watch,
                  errors: errors,
                  uniqueFormPrefix: uniqueFormPrefix,
                  utmParameters: utmParameters,
                  settings: settings
                }, field.id);
              })
            })) : jsx(FormComponentsRenderer, {
              WrappedComponent: componentsMap[fieldGroup.type],
              props: fieldGroup,
              register: register,
              setValue: setValue,
              unregister: unregister,
              watch: watch,
              errors: errors,
              uniqueFormPrefix: uniqueFormPrefix,
              utmParameters: utmParameters,
              settings: settings
            }, fieldGroup.id);
          })
        }), data.sections[currentStep].id), data.sections.length > 1 ? jsxs("div", Object.assign({
          className: "cds-promo-form__section-button-container"
        }, {
          children: [data.sections[currentStep].backButtonText ? jsx(Button, Object.assign({
            type: "button",
            className: "cds-promo-form__section-button",
            onClick: handlePrevious,
            "aria-label": data.sections[currentStep].backButtonDescription || data.sections[currentStep].backButtonText,
            disabled: currentStep === 0
          }, {
            children: data.sections[currentStep].backButtonText || ''
          })) : null, data.sections[currentStep].submitButtonText ? jsx(Button, Object.assign({
            onClick: currentStep === data.sections.length - 1 ? undefined : handleNext,
            type: currentStep === data.sections.length - 1 ? 'submit' : 'button',
            className: "cds-promo-form__section-button",
            "aria-label": data.sections[currentStep].submitButtonDescription || data.sections[currentStep].submitButtonText
          }, {
            children: data.sections[currentStep].submitButtonText
          })) : null]
        })) : null]
      }) : null, jsx(ErrorMessage, {
        message: formError
      }), data && currentStep === data.sections.length - 1 && data.sections.length === 1 ? jsx(Button, Object.assign({
        type: "submit",
        size: "small",
        variant: "primary",
        className: "cds-promo-form__submit-button",
        disabled: isSubmitting || disabled,
        "aria-label": data.submitButtonDescription || data.submitButtonText
      }, {
        children: data.submitButtonText
      })) : null]
    })), jsx(GoogleReCaptcha, {
      action: formId.replace(/-/g, ''),
      onVerify: handleToken
    })]
  }));
};
var queryClient = new QueryClient();
var PromoFormBlock = forwardRef(function (_ref13, ref) {
  var className = _ref13.className,
    url = _ref13.url,
    settings = _ref13.settings,
    formId = _ref13.formId,
    submitErrorMessage = _ref13.submitErrorMessage,
    onSuccessCallback = _ref13.onSuccessCallback,
    onRedirectCallback = _ref13.onRedirectCallback,
    utmParameters = _ref13.utmParameters,
    align = _ref13.align,
    showHeading = _ref13.showHeading,
    disabled = _ref13.disabled,
    _ref13$thankYouPageRe = _ref13.thankYouPageRedirect,
    thankYouPageRedirect = _ref13$thankYouPageRe === void 0 ? false : _ref13$thankYouPageRe;
  return jsx("div", Object.assign({
    ref: ref,
    className: classNames('cds-promo-form-block', className)
  }, {
    children: jsx(QueryClientProvider, Object.assign({
      client: queryClient
    }, {
      children: jsx(PromoForm, {
        url: url,
        settings: settings,
        formId: formId,
        submitErrorMessage: submitErrorMessage,
        utmParameters: utmParameters,
        onSuccessCallback: onSuccessCallback,
        onRedirectCallback: onRedirectCallback,
        align: align,
        showHeading: showHeading,
        disabled: disabled,
        thankYouPageRedirect: thankYouPageRedirect
      })
    }))
  }));
});
export { PromoFormBlock };